import type * as React from "react"
import { useTokenRefreshMutation } from "@digits-graphql/admin/graphql-public"
import useSessionTokenRefresh from "src/shared/components/Session/useSessionTokenRefresh"

export const AdminBearerRefresh: React.FC = () => {
  const [tokenRefreshMutation] = useTokenRefreshMutation()
  useSessionTokenRefresh(tokenRefreshMutation)
  return null
}
